import React from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "src/context/ThemeContext";

interface BalanceWidgetProps {
  balance: {
    amount: number;
    creditLimit?: number;
    currency?: string;
    paymentType?: string;
  };
  isMinimized?: boolean;
}

const BalanceWidget: React.FC<BalanceWidgetProps> = ({
  balance,
  isMinimized = false,
}) => {
  const { t } = useTranslation();
  const { theme } = useTheme();
  const formatCurrency = (amount: number, currency: string = "Rp") => {
    if (currency === "Rp") {
      return `${currency} ${amount < 0 ? "(" : ""}${Math.abs(
        amount
      ).toLocaleString("id-ID")}${amount < 0 ? ")" : ""}`;
    }
    return `${currency} ${amount < 0 ? "(" : ""}${Math.abs(
      amount
    ).toLocaleString()}${amount < 0 ? ")" : ""}`;
  };

  const formatPaymentType = (paymentType: string) => {
    // Normalize the payment type to match translation keys
    const normalizedType =
      paymentType.charAt(0).toUpperCase() + paymentType.slice(1).toLowerCase();

    // Try to get translation, fallback to formatted original if not found
    const translationKey = `SideBar.BalanceWidget.PaymentType.${normalizedType}`;
    return t(translationKey, normalizedType);
  };

  console.log(theme, "theme balance widget");

  if (isMinimized) {
    return (
      <div className="tw-mb-4">
        <div className="tooltip tooltip-right tw-flex tw-justify-center">
          <button
            className={`tw-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-rounded-lg ${
              theme === "light"
                ? "tw-bg-primary/10 tw-text-primary hover:tw-bg-primary/20"
                : "tw-bg-slate-600 tw-text-slate-300 hover:tw-bg-slate-500"
            }`}
          >
            <span className="material-symbols-outlined">
              account_balance_wallet
            </span>
          </button>
          <span className="tooltiptext">
            {t("SideBar.BalanceWidget.Balance")}:{" "}
            {formatCurrency(balance.amount, balance.currency)}
            {balance.creditLimit && (
              <>
                <br />
                {t("SideBar.BalanceWidget.CreditLimit")}:{" "}
                {formatCurrency(balance.creditLimit, balance.currency)}
              </>
            )}
            <br />({formatPaymentType(balance.paymentType || "Postpaid")})
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="tw-mb-4">
      <div
        className={`tw-rounded-lg tw-p-3 tw-flex tw-flex-col tw-gap-2 ${
          theme === "light" ? "tw-bg-slate-100" : "tw-bg-primary/10"
        }`}
      >
        <div className="tw-flex tw-items-center tw-justify-between">
          <span
            className={`tw-text-xs tw-font-medium ${
              theme === "light" ? "tw-text-slate-500" : "tw-text-slate-300"
            }`}
          >
            {t("SideBar.BalanceWidget.Balance")}
          </span>
          <span
            className={`tw-text-sm tw-font-semibold ${
              theme === "light" ? "tw-text-slate-800" : "tw-text-slate-100"
            }`}
          >
            {formatCurrency(balance.amount, balance.currency)}
          </span>
        </div>
        {balance.creditLimit && (
          <div className="tw-flex tw-items-center tw-justify-between">
            <span
              className={`tw-text-xs tw-font-medium ${
                theme === "light" ? "tw-text-slate-500" : "tw-text-slate-300"
              }`}
            >
              {t("SideBar.BalanceWidget.CreditLimit")}
            </span>
            <span
              className={`tw-text-sm tw-font-semibold ${
                theme === "light" ? "tw-text-slate-800" : "tw-text-slate-100"
              }`}
            >
              {formatCurrency(balance.creditLimit, balance.currency)}
            </span>
          </div>
        )}
        <div className="tw-flex tw-items-center tw-justify-between">
          <span
            className={`tw-text-xs tw-font-medium ${
              theme === "light" ? "tw-text-slate-500" : "tw-text-slate-300"
            }`}
          >
            {t("SideBar.BalanceWidget.Payment")}
          </span>
          <span
            className={`tw-text-sm tw-font-semibold ${
              theme === "light" ? "tw-text-slate-800" : "tw-text-slate-100"
            }`}
          >
            {formatPaymentType(balance.paymentType || "Postpaid")}
          </span>
        </div>
      </div>
    </div>
  );
};

export default BalanceWidget;
